import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

interface GuardProps {
  children: ReactNode
}

const AuthGuard = ({ children }: GuardProps): JSX.Element | null => {
  const { isLoggedIn, isLoading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading && !isLoggedIn) {
      navigate('/login', { replace: true })
    }
  }, [isLoading, isLoggedIn, navigate])

  return <div>{children}</div>
}

export default AuthGuard
